<template>
<div class="chapter">
<div class="inner_page">
<div class="preface" id="ada">
<h1 class="subchapter"><img alt="" src="OEBPS/images/9780865477377_ada.png"/><br/><em>Tom Lutz</em></h1>
<h1 class="subchapter">DOING NOTHING</h1>
<p class="nonindent">Tom Lutz is the author of <em>Crying: The Natural and Cultural History of Tears</em>, which <em>The Washington Post</em> called “a tour de force of erudition.” His other books include <em>American Nervousness, 1903: An Anecdotal History</em> and <em>Cosmopolitan Vistas: American Regionalism and Literary Value.</em> He lives in Los Angeles.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780865477377_epub_ada_r1.vue?311d4564